import CallHandler from "./modules/CallHandler";

void CallHandler.handleCall();
